<template>
  <div class="user">
    <div class="header bg-color-red acea-row row-between-wrapper">
      <div class="picTxt acea-row row-between-wrapper" @click="userInfo.phone ? $router.push({ path: '/user/data' }):''">
        <div class="pictrue"><img :src="userInfo.avatar" @error="getDefaultAvatar" /></div>
        <div class="text" v-if="userInfo.phone">
          <div
            class="acea-row row-middle"
          >
            <div class="name line1">{{ userInfo.nickname }}</div>
            <div class="member acea-row row-middle" v-if="userInfo.vip">
              <img :src="userInfo.vip_icon" />{{ userInfo.vip_name }}
            </div>
          </div>
          <div class="grade">{{ userInfo.level }}</div>
        </div>
        <div class="text" v-if="!userInfo.phone" @click="$router.push('/bind_mobile')">
            <div class="name line1">请登录</div>
        </div>
      </div>
      <div class="word" @click="$router.push({ path: '/user/news' })" v-if="userInfo.notice>=0">
        消息{{userInfo.notice==0 ? '':'('+userInfo.notice+')'}}
      </div>
      <span
        class="iconfont icon-shezhi"
        @click="$router.push({ path: '/user/setting' })"
      ></span>
      <div class="right-jian" @click="$router.push({ path: '/user/data' })">
        <img src="../../assets/newImg/icon_right_white.png" alt="" />
      </div>
    </div>
    <div class="wrapper wrapper-order">
      <div class="bg-list-work">
            <div class="myOrder">
                <div class="title acea-row row-between-wrapper">
                    <div>我的订单</div>
                    <router-link :to="'/order/list/'+8" class="allOrder">
                        全部订单<span class="iconfont icon-jiantou"></span>
                    </router-link>
                </div>
                <div class="orderState acea-row row-middle">
                    <router-link :to="{ path: '/order/list/' + 0 }" class="item">
                        <div class="pictrue">
                            <img src="@assets/images/dfk.png" />
                            <span class="order-status-num" v-if="orderStatusNum.unpaid_count > 0">{{ orderStatusNum.unpaid_count }}</span>
                        </div>
                        <div>待付款</div>
                    </router-link>
                    <router-link :to="{ path: '/order/list/' + 1 }" class="item">
                        <div class="pictrue">
                            <img src="@assets/images/dfh.png" />
                            <span class="order-status-num" v-if="orderStatusNum.unshipped_count > 0">{{ orderStatusNum.unshipped_count }}</span>
                        </div>
                        <div>待发货</div>
                    </router-link>
                    <router-link :to="{ path: '/order/list/' + 2 }" class="item">
                        <div class="pictrue">
                            <img src="@assets/images/dsh.png" />
                            <span class="order-status-num" v-if="orderStatusNum.received_count > 0">{{ orderStatusNum.received_count }}</span>
                        </div>
                        <div>待收货</div>
                    </router-link>
                    <router-link :to="{ path: '/order/list/' + 3 }" class="item">
                        <div class="pictrue">
                            <img src="@assets/images/dpj.png" />
                            <span class="order-status-num" v-if="orderStatusNum.evaluated_count > 0">{{ orderStatusNum.evaluated_count }}</span>
                        </div>
                        <div>待评价</div>
                    </router-link>
                    <router-link :to="'/order/refund_list'" class="item">
                        <div class="pictrue">
                            <img src="@assets/images/sh.png" />
                            <span class="order-status-num" v-if="orderStatusNum.refund_count > 0">{{ orderStatusNum.refund_count }}</span>
                        </div>
                        <div>售后/退款</div>
                    </router-link>
                </div>
            </div>
            <div class="work-list row-flex">
            <div class="work-li" @click="$router.push('/user/income')">
                <div class="work-li-top text-color">{{commissionContent.current_money}}</div>
                <div class="work-li-bottom">
                    <div class="txt">{{commissionContent.current_text}}</div>
                    <div class="work-time">{{commissionContent.current_time}}</div>
                </div>
            </div>
            <div class="line-white"></div>
            <div class="work-li" @click="$router.push('/user/vip')">
                <div class="work-li-top text-color">{{commissionContent.team_money}}</div>
                <div class="work-li-bottom">
                    <div class="txt">{{commissionContent.team_text}}</div>
                    <div class="work-time">{{commissionContent.team_diff}}</div>
                </div>
            </div>
            <div class="line-white"></div>
            <div class="work-li" @click="$router.push('/user/my_points')">
                <div class="work-li-top text-color">{{commissionContent.integral}}</div>
                <div class="work-li-bottom">
                    <div class="txt">{{commissionContent.integral_text}}</div>
                    <div class="work-time">{{commissionContent.integral_underway}}</div>
                </div>
            </div>
        </div>
        </div>

    </div>
    <div class="wrapper">
            <div class="myService">
                <!-- <div class="title acea-row row-middle">我的功能</div> -->
                <div class="serviceList acea-row row-middle">
                    <template v-for="(item, index) in MyMenusWork">
                        <div class="item" :key="index" @click="goPages(item.wap_url)" v-if="item.wap_url">
                            <div class="pictrue">
                                <img :src="item.pic" />
                            </div>
                            <div>{{ item.name }}</div>
                        </div>
                    </template>
                </div>
            </div>
            <div class="myService">
                <div class="title acea-row row-middle">子公司信息</div>
                <div class="serviceList acea-row row-middle" >
                    <template v-for="(item, index) in MyMenusCompany">
                        <div class="item" style="width:33.33%;font-weight:600"  :key="index" @click="userInfo.is_subsidiary == 1?goPages(item.wap_url):noGo()" v-if="item.wap_url">
                            <div class="pictrue">
                                <img :src="item.pic" />
                            </div>
                            <div style="font-weight:600">{{ item.name }}</div>
                        </div>
                    </template>
                </div>
            </div>
            <div class="myService work-ke">
                <div class="title acea-row row-middle">更多工具</div>
                <div class="serviceList acea-row row-middle">
                    <template v-for="(item, index) in MyMenusMore">
                        <div class="item" :key="index" @click="goPages(item.wap_url)" v-if="item.wap_url">
                            <div class="pictrue" style="margin-bottom:0">
                                <img :src="item.pic" style="width:18px;height:18px" />
                            </div>
                            <div>{{ item.name }}</div>
                        </div>
                    </template>
                </div>
            </div>
            <div style="height:0.3rem"></div>
        </div>
        <!-- <img src="@assets/images/support.png" class="support" /> -->
        <div class="footer-line-height"></div>
        <SwitchWindow v-on:changeswitch="changeswitch" :switchActive="switchActive" :login_type="userInfo.login_type"></SwitchWindow>
        <GeneralWindow :generalActive="generalActive" @closeGeneralWindow="closeGeneralWindow" :generalContent="generalContent"></GeneralWindow>
    </div>
</template>

<script>
import { getUser, getMenuUser,commission } from "@api/user";
import { isWeixin } from "@utils";
import SwitchWindow from "@components/SwitchWindow";
import GeneralWindow from "@components/GeneralWindow";
import cookie from "@utils/store/cookie";

const NAME = "User";
export default {
    name: NAME,
    components: {
        SwitchWindow,
        GeneralWindow,
    },
    props: {},
    data: function () {
        return {
            userInfo: {},
            MyMenus: [],
            MyMenusWork: [
                {
                    name: "我的团队",
                    wap_url: "/myTeam",
                    pic: require("../../assets/newImg/work1.png"),
                },
                {
                    name: "我的收入",
                    wap_url: "/user/income",
                    pic: require("../../assets/newImg/work2.png"),
                },
                {
                    name: "分享海报",
                    wap_url: "/user/poster",
                    pic: require("../../assets/newImg/work3.png"),
                },
                {
                    name: "业绩详情",
                    wap_url: "/myPerformance",
                    pic: require("../../assets/newImg/work4.png"),
                },
                {
                    name: "我的积分",
                    wap_url: "/user/my_points",
                    pic: require("../../assets/newImg/work5.png"),
                },
                {
                    name: "会员中心",
                    wap_url: "/user/vip",
                    pic: require("../../assets/newImg/work6.png"),
                },
                {
                    name: "我的收藏",
                    wap_url: "/collection",
                    pic: require("../../assets/newImg/work7.png"),
                },
                {
                    name: "邀请记录",
                    wap_url: "/user/record_friends",
                    pic: require("../../assets/newImg/work8.png"),
                },
            ],
            MyMenusCompany: [
                {
                    name: "子公司人员",
                    wap_url: "/childPerson",
                    pic: require("../../assets/newImg/peo_1.png"),
                },
                {
                    name: "子公司业绩",
                    wap_url: "/chileIndex",
                    pic: require("../../assets/newImg/peo_2.png"),
                },
                {
                    name: "子公司详情",
                    wap_url: "/childDetail",
                    pic: require("../../assets/newImg/peo_3.png"),
                },
            ],
            MyMenusMore: [
                {
                    name: "线上客服",
                    wap_url: "/kefu",
                    pic: require("../../assets/newImg/more_work_1.png"),
                },
                {
                    name: "线下客服",
                    wap_url: "/offlineContact",
                    pic: require("../../assets/newImg/more_work_2.png"),
                },
                {
                    name: "地址信息",
                    wap_url: "/user/add_manage",
                    pic: require("../../assets/newImg/more_work_3.png"),
                },
                {
                    name: "常见问题",
                    wap_url: "/problem",
                    pic: require("../../assets/newImg/more_work_4.png"),
                },
            ],
            orderStatusNum: {},
            switchActive: false,
            isWeixin: false,
            generalActive: false,
            generalContent: {
                promoterNum: "",
                title: "",
            },
            commissionContent:{}
        };
    },
    watch: {
        $route(n) {
            if (n.name === NAME) this.User();
        },
    },
    mounted: function () {
        this._onShowLoading();
        localStorage.removeItem('historyRouter')
        localStorage.removeItem('historyAppShareLink')
        this.User();
        this.commissionShow()
        this.MenuUser();
        this.isWeixin = isWeixin();
    },
    methods: {
        getDefaultAvatar () {
            this.userInfo.avatar = 'http://app.shangpinbaoshi.com/default_avatar.png'
        },
        commissionShow(){
            commission().then(res=>{
                this.commissionContent=res.data.info
            })
        },
        noGo() {
            this.$dialog.toast({ mes: "您暂时不是子公司用户，无权限查看" });
        },
        changeswitch: function (data) {
            this.switchActive = data;
        },
        User: function () {
            let that = this;
            getUser().then((res) => {
                that.userInfo = res.data;
                that.orderStatusNum = res.data.orderStatusNum;
                this.generalContent = {
                    promoterNum: `您在商城累计消费金额仅差 <span style="color: #ff8500;">${
                        res.data.promoter_price || 0
                    }元</span>即可开通推广权限`,
                    title: "您未获得推广权限",
                };
                this._onHideLoading();
            })
            .catch(() => {
                this._onHideLoading();
            })
        },
        MenuUser: function () {
            let that = this;
            getMenuUser().then((res) => {
                that.MyMenus = res.data.routine_my_menus;
            });
        },
        goPagey(url) {
            if (!this.userInfo.is_promoter && this.userInfo.statu == 1)
                return this.$dialog.toast({ mes: "您还没有推广权限！！" });
            if (!this.userInfo.is_promoter && this.userInfo.statu == 2) {
                return (this.generalActive = true);
            }
            this.$router.push({ path: url });
        },
        goPages: function (url) {
            // let url = this.MyMenus[index].wap_url;
            // if (url === "/user/user_promotion") {
            //   if (!this.userInfo.is_promoter && this.userInfo.statu == 1)
            //     return this.$dialog.toast({ mes: "您还没有推广权限！！" });
            //   if (!this.userInfo.is_promoter && this.userInfo.statu == 2) {
            //     return (this.generalActive = true);
            //   }
            // }
            // if (url === "/customer/index" && !this.userInfo.adminid) {
            //   return this.$dialog.toast({ mes: "您还不是客服！！" });
            // }

            if(url=='/kefu'){
        window.location.href=this.Constants.WECHAT_CUSTOMER_SERVICES
        // window.location.href='https://yzf.qq.com/xv/web/static/chat/index.html?sign=37ef9b97837c00c12a41cdeb48e1b16bf31751d88ee5b6e37f40f78461b5787e707a343e71f934fcc1bcb54af3b0ab33106f9d36'
        return
      }
      this.$router.push({ path: url });
        },
        closeGeneralWindow(msg) {
            this.generalActive = msg;
        },
    },
};
</script>

<style scoped>
.footer-line-height {
    height: 1rem;
}
.order-status-num {
    min-width: 0.33rem;
    background-color: #fff;
    color: #ee5a52;
    border-radius: 15px;
    position: absolute;
    right: -0.14rem;
    top: -0.15rem;
    font-size: 0.2rem;
    padding: 0 0.08rem;
    border: 1px solid #ee5a52;
}

.pictrue {
    position: relative;
}
.switch-h5 {
    margin-left: 0.2rem;
}
.binding {
    padding: 0.05rem 0.2rem;
    background-color: #ca1f10;
    border-radius: 50px;
    font-size: 0.14rem;
    border: 1px solid #e8695e;
    color: #ffffff;
}
.grade {
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border-radius: 12px;
    text-align: center;
    color: #d01112;
    font-size: 12px;
    margin-top: 8px;
    width: fit-content;
    padding: 0 13px;
}
.word {
    position: absolute;
    top: 15px;
    right: 60px;
    color: #fff;
}
.user .header .icon-shezhi {
    margin-top: auto;
}
.right-jian img {
    width: 9px;
    height: 18px;
}
.icon-shezhi {
    position: absolute;
    top: 15px;
    right: 20px;
}
.user .header {
    height: 2.4rem;
}
.user .header:after {
    background-color: #d01112;
}
.bg-list-work{
    background: url('../../assets/newImg/mine-bg.png') no-repeat;
    background-size: 100% 100%;
    min-height: 260px;
    margin: 0 10px;
}
.user .wrapper .myOrder{
    margin:0 20px 0 20px;
}
.wrapper-order{
    padding: 0 !important;
}
.wrapper-order .work-list{
    margin-top: 39px;
    display: flex;
    align-items: center;

}
.wrapper-order .work-list .work-li{
width: 33.33%;
height: 100px;
text-align: center;
display: flex;
align-items: center;
flex-direction: column;
}
.wrapper-order .work-list .work-li .work-li-top{
    font-size: 20px;
    font-weight: 600;
}
.wrapper-order .work-list .work-li .work-li-bottom{
    padding: 11px 11px 0 11px;
}
.wrapper-order .work-list .work-li .work-li-bottom .txt{
    color: #323130;
    font-size: 14px;
}
.wrapper-order .work-list .work-li .work-li-bottom .work-time{
    color: #999999;
    padding-top: 5px;
    font-size: 12px;
}
.line-white{
  width: 2px;
height: 56px;
background: #ffffff;
border-radius: 2px;  
}
.user .wrapper .myService .serviceList .item{
    font-size: 13px;
}
.work-ke{
background: #ffffff;
border-radius: 10px;
box-shadow: 0px 1px 15px 0px rgba(157,157,157,0.20);   
}
.user .wrapper .myService .serviceList .item .pictrue{
    margin: 0 auto 0.1rem auto;
}
.user .wrapper .myOrder .orderState .item .pictrue{
    height: auto;
}
.user .wrapper .myOrder .orderState .item .pictrue{
   margin: 0 auto 0.12rem auto; 
}
</style>
